"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getClassNames = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _react = require("@fluentui/react");

var _stylingConstants = require("../../styling/stylingConstants");

var _ExtendedDialog = require("./ExtendedDialog.types");

var getClassNames = (0, _react.memoizeFunction)(function (dialogSize) {
  var sizing = (0, _defineProperty2.default)({}, "@media (min-width: ".concat(_react.ScreenWidthMinMedium, "px)"), {
    selectors: {
      '.ms-Dialog-main': {
        maxWidth: _stylingConstants.columnUnit * 1.5,
        minWidth: _stylingConstants.columnUnit * 1.5
      }
    }
  });

  if (dialogSize === _ExtendedDialog.DialogSize.large) {
    sizing["@media (min-width: ".concat(_react.ScreenWidthMinLarge, "px)")] = {
      selectors: {
        '.ms-Dialog-main': {
          maxWidth: _stylingConstants.gridUnit * 78,
          minWidth: _stylingConstants.gridUnit * 78
        }
      }
    };
    sizing["@media (min-width: ".concat(_react.ScreenWidthMinXLarge, "px)")] = {
      selectors: {
        '.ms-Dialog-main': {
          maxWidth: _stylingConstants.gridUnit * 90,
          minWidth: _stylingConstants.gridUnit * 90
        }
      }
    };
  }

  return {
    root: (0, _react.mergeStyles)({
      selectors: sizing
    })
  };
});
exports.getClassNames = getClassNames;